import {Action} from "redux";

import {DataRetention} from "../../models";

export enum DataRetentionActionTypes {
  UPDATE_DATA_RETENTION_REQUEST = 'dataRetention/data_retention_update_request',
  UPDATE_DATA_RETENTION_SUCCESS = 'dataRetention/data_retention_update_success',
  UPDATE_DATA_RETENTION_FAILURE = 'dataRetention/data_retention_update_failure',
}

// Interfaces

export interface UpdateDataRetentionRequestAction extends Action {
  type: DataRetentionActionTypes.UPDATE_DATA_RETENTION_REQUEST;
  payload: {
    DataRetention: DataRetention;
  }
}

export interface UpdateDataRetentionSuccessAction extends Action {
  type: DataRetentionActionTypes.UPDATE_DATA_RETENTION_SUCCESS;
}

export interface UpdateDataRetentionFailureAction extends Action {
  type: DataRetentionActionTypes.UPDATE_DATA_RETENTION_FAILURE;
}

// Functions

export function updateDataRetentionRequest(DataRetention: DataRetention): UpdateDataRetentionRequestAction {
  return {
    type: DataRetentionActionTypes.UPDATE_DATA_RETENTION_REQUEST,
    payload: {
      DataRetention
    }
  };
}

export function updateDataRetentionSuccess(): UpdateDataRetentionSuccessAction {
  return {
    type: DataRetentionActionTypes.UPDATE_DATA_RETENTION_SUCCESS,
  };
}

export function updateDataRetentionFailure(): UpdateDataRetentionFailureAction {
  return {
    type: DataRetentionActionTypes.UPDATE_DATA_RETENTION_FAILURE,
  };
}

export type DataRetentionActions =
  UpdateDataRetentionRequestAction |
  UpdateDataRetentionSuccessAction |
  UpdateDataRetentionFailureAction;
